module.exports = __webpack_public_path__ + "img/src_donut.61665fe5.svg";